// Vessel Endpoints Constants
export const VESSEL_ENDPOINTS = {
  // Vessel Operations
  VESSEL: "/vessel",
  VESSELS: "/vessels",
} as const;
